import { UseFormRegisterReturn } from "react-hook-form"
import { StyledTimeInput, TimeInputContainer } from "./TimeInput.styled"

interface TimeInputProps {
  /**
   * The React Hook Form register return object
   */
  registerReturn: UseFormRegisterReturn
}

/**
 * Generic TimeInput component for React Hook Form.
 * This component renders a styled HTML time input with React Hook Form integration.
 * All validations are controlled externally through register options.
 *
 * @example
 * ```tsx
 * <TimeInput
 *   registerReturn={register("startTime", { required: "Start time is required" })}
 * />
 * ```
 */
export const TimeInput = ({ registerReturn }: TimeInputProps) => {
  return (
    <TimeInputContainer alignItems="center">
      <StyledTimeInput type="time" {...registerReturn} />
    </TimeInputContainer>
  )
}
